// extracted by mini-css-extract-plugin
export default {"steps_box":"BsaNewSteps_steps_box__8v74r"};